import { render, staticRenderFns } from "./invite-client-admin-dialog.component.vue?vue&type=template&id=03d82dce"
import script from "./invite-client-admin-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./invite-client-admin-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d82dce')) {
      api.createRecord('03d82dce', component.options)
    } else {
      api.reload('03d82dce', component.options)
    }
    module.hot.accept("./invite-client-admin-dialog.component.vue?vue&type=template&id=03d82dce", function () {
      api.rerender('03d82dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/account-setup/invite-client-admin-dialog/invite-client-admin-dialog.component.vue"
export default component.exports